import React, { useEffect, useState } from 'react';
import { Trial } from '../../redux/types';
import ApiClient from '../../loopback/apiClient';

const useGetTrialById = (trialId?: number) => {
  const [trial, setTrial] = useState<Trial>();

  useEffect(() => {
    if (!trialId) {
      return;
    }
    ApiClient.getTrialById(trialId)
      .then((t) => { setTrial(t); });
  }, [trialId]);
  return trial;
};

export default useGetTrialById;
